import { render, staticRenderFns } from "./auto-message-template-search.vue?vue&type=template&id=7bc8c78f&scoped=true&"
import script from "./auto-message-template-search.vue?vue&type=script&lang=js&"
export * from "./auto-message-template-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc8c78f",
  null
  
)

export default component.exports